import { createFileRoute } from '@tanstack/react-router';

import { SupplierAnalyticsPage } from '@/features/supplier/analytics-page';

export const Route = createFileRoute('/_app/supplier/$orgId/analytics')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierAnalyticsPage {...params} />;
}
